import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DynamicFieldValueService {


  url = environment.serverAPI4+'/api/dynamicFieldValues';
	cartCount: Response[];

	constructor(private http: HttpClient) { }

	

	getALLFieldValues(leadId,activityId): Observable<Response[]> {
		return this.http.get<any>(`${this.url}/${leadId}/${activityId}`);
	}
}
